import Typography from "@mui/material/Typography";
import React from "react";
import { serviceDayOffsetMinutes } from "utils/display";
import usePolledValue from "utils/usePolledValue";

// Hours and minutes, because a quarter-hour zone is a real offset: Kathmandu
// is 3 hours 45 minutes off the service day, not 3.8 hours of anything.
const offsetLabel = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return [
    hours && `${hours} ${hours === 1 ? "hour" : "hours"}`,
    rest && `${rest} minutes`,
  ]
    .filter(Boolean)
    .join(" ");
};

// Every day on the dashboard is the South African service day, which reads as
// the wrong day to anyone whose clock is elsewhere: their "today" cards turn
// over mid-afternoon.
export default function ServiceDayNotice() {
  // Polled rather than read once: the viewer's own DST switch moves this while
  // the dashboard is open, which on a kitchen screen is weeks at a time.
  const offset = usePolledValue(serviceDayOffsetMinutes);

  if (offset === 0) {
    return null;
  }
  return (
    <Typography
      variant="caption"
      sx={{ display: "block", mt: 0.5, color: "text.secondary" }}
    >
      Days on this dashboard follow the South African service day (SAST),{" "}
      {offsetLabel(Math.abs(offset))} {offset > 0 ? "ahead of" : "behind"} your
      clock.
    </Typography>
  );
}
